module.exports = __webpack_public_path__ + "static/img/live_icon.105e3b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/live_icon.png
// module id = s2Gy
// module chunks = 4